module.exports = __webpack_public_path__ + "img/00042.444b97cb.webp";